var map = {
	"./Expandable.js": 7614,
	"./FoodWasteQuiz.js": 4307,
	"./FoodWasteRadios.js": 7350,
	"./FoodWasteResultTabs.js": 615,
	"./FoodWasteSlider.js": 8587,
	"./Header.js": 8867,
	"./IframeResizer.js": 2290,
	"./Ingredients.js": 1387,
	"./Quiz.js": 3055,
	"./ShareLinks.js": 8750,
	"components/Expandable.js": 7614,
	"components/FoodWasteQuiz.js": 4307,
	"components/FoodWasteRadios.js": 7350,
	"components/FoodWasteResultTabs.js": 615,
	"components/FoodWasteSlider.js": 8587,
	"components/Header.js": 8867,
	"components/IframeResizer.js": 2290,
	"components/Ingredients.js": 1387,
	"components/Quiz.js": 3055,
	"components/ShareLinks.js": 8750
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8965;